var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Suspense, useEffect, useState } from "react";
import { fetchUserDetails, getTimeToRentExpiryInMilliSeconds } from "../../helpers";
import pubsub from "@viewlift/pubsub";
import { handlePlansCheck, handleTVEPlansCheck } from "../../components/MonetizationBadge/helper";
import { isTvodSubscribed } from "../../Hardwall/helper";
import { subscribeRedirectWithOptions } from "../../OnBoarding-V2/Events/utils.events";
import { getStorageItem, setStorageItem } from "../../helpers/storageManager";
import Spinner from "../../components/spinner";
var VideoDetail02 = function (props) {
    var _a, _b, _c;
    var monetizationModels = ((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.moduleData) === null || _a === void 0 ? void 0 : _a.contentData) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.monetizationModels) || [];
    var isFreeModal = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "FREE"; });
    var isTveModal = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "TVE"; });
    var isSvodModal = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "SVOD"; });
    var isAvodModal = monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.some(function (model) { return (model === null || model === void 0 ? void 0 : model.type) === "AVOD"; });
    var _d = __read(useState(null), 2), user = _d[0], setUser = _d[1];
    var _e = __read(useState(false), 2), showCheckout = _e[0], setShowCheckout = _e[1];
    /**
     * @param {boolean?} didRentedContentExpire - Flag that specifies that the rented TVOD content has expired its rental period and user is no longer TVOD subscribed for the given content; show checkout page
     */
    var isUserAvailable = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], __read(args_1), false), void 0, function (didRentedContentExpire) {
            var redirected, _a, userId, user, plans, tveProvider, isTveLoggedIn, isFreeContent, isSubscribed, isUserTvodSubscribed, _b, isLoginOrEmailReq;
            var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            if (didRentedContentExpire === void 0) { didRentedContentExpire = false; }
            return __generator(this, function (_s) {
                switch (_s.label) {
                    case 0:
                        redirected = getStorageItem("isRedirected");
                        return [4 /*yield*/, fetchUserDetails()];
                    case 1:
                        _a = _s.sent(), userId = _a.userId, user = _a.user;
                        plans = (_e = (_d = (_c = props === null || props === void 0 ? void 0 : props.moduleData) === null || _c === void 0 ? void 0 : _c.contentData) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.plans;
                        tveProvider = (user === null || user === void 0 ? void 0 : user.tveProvider) || ((_f = user === null || user === void 0 ? void 0 : user.tveMetadata) === null || _f === void 0 ? void 0 : _f.tveProvider);
                        isTveLoggedIn = false;
                        if (tveProvider && ((_g = user === null || user === void 0 ? void 0 : user.subscription) === null || _g === void 0 ? void 0 : _g.tveSubscriptions)) {
                            isTveLoggedIn = handleTVEPlansCheck(user, plans);
                        }
                        isFreeContent = (monetizationModels === null || monetizationModels === void 0 ? void 0 : monetizationModels.length) ? isFreeModal : true;
                        isSubscribed = handlePlansCheck(user, (_k = (_j = (_h = props === null || props === void 0 ? void 0 : props.moduleData) === null || _h === void 0 ? void 0 : _h.contentData) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.plans);
                        if (!didRentedContentExpire) return [3 /*break*/, 2];
                        _b = false;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, isTvodSubscribed((_p = (_o = (_m = (_l = props === null || props === void 0 ? void 0 : props.moduleData) === null || _l === void 0 ? void 0 : _l.contentData) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.gist) === null || _p === void 0 ? void 0 : _p.id)];
                    case 3:
                        _b = _s.sent();
                        _s.label = 4;
                    case 4:
                        isUserTvodSubscribed = _b;
                        isLoginOrEmailReq = false;
                        if (isFreeContent) {
                            isLoginOrEmailReq = ((_r = (_q = props === null || props === void 0 ? void 0 : props.moduleData) === null || _q === void 0 ? void 0 : _q.plans) === null || _r === void 0 ? void 0 : _r.some(function (plan) {
                                var _a, _b;
                                return (plan === null || plan === void 0 ? void 0 : plan.monetizationModel) === "FREE" &&
                                    !isLoginOrEmailReq &&
                                    (((_a = plan === null || plan === void 0 ? void 0 : plan.featureSetting) === null || _a === void 0 ? void 0 : _a.isLoginRequired) || ((_b = plan === null || plan === void 0 ? void 0 : plan.featureSetting) === null || _b === void 0 ? void 0 : _b.isEmailRequired));
                            })) || false;
                        }
                        // Conditions to set user and show checkout module
                        if ((user && isSubscribed && isSvodModal) || // User is subscribed with SVOD modal
                            (user && isTveLoggedIn && isTveModal) || // User is logged in via TVE and it's TVE modal
                            (user && isUserTvodSubscribed) || (user && isAvodModal) || isFreeContent // User is subscribed to TVOD content
                        ) {
                            setUser(userId); // Set the user ID
                            setShowCheckout(false); // No checkout needed
                        }
                        else {
                            // User is not logged in
                            if ((isFreeContent && !isLoginOrEmailReq) || isAvodModal) {
                                setUser("nonSubscribedUser");
                                setShowCheckout(false); // Show checkout
                            }
                            else {
                                // Content does not have plans and user is not logged in
                                setUser("nonSubscribedUser");
                                setStorageItem("isRedirected", __assign(__assign({}, redirected), { redirect: false, isDetailPage: true }));
                                setShowCheckout(true); // No checkout needed
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleCheckoutFlow = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var store, user, isUsersubscribed;
        return __generator(this, function (_a) {
            store = getStorageItem("AuthenticationStore");
            user = store === null || store === void 0 ? void 0 : store.user;
            isUsersubscribed = handlePlansCheck(user, data.plans);
            if (!isUsersubscribed) {
                setShowCheckout(true);
            }
            return [2 /*return*/];
        });
    }); };
    var renderLazyComponent = function () {
        var LazyComponent = React.lazy(function () {
            return showCheckout && user === "nonSubscribedUser"
                ? import("../CheckoutModule/index")
                : import("../VideoDetailModule/index");
        });
        return React.createElement(LazyComponent, __assign({}, props, { isVideoPage: true }));
    };
    var handleNavigate = function (data) {
        var _a, _b;
        if ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) {
            window.location.href = (data === null || data === void 0 ? void 0 : data.path) || ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.pathname);
        }
    };
    useEffect(function () {
        var _a, _b, _c, _d;
        var _delay = null;
        var contentId = ((_b = (_a = props === null || props === void 0 ? void 0 : props.moduleData) === null || _a === void 0 ? void 0 : _a.contentData) === null || _b === void 0 ? void 0 : _b.length) && ((_d = (_c = props.moduleData.contentData[0]) === null || _c === void 0 ? void 0 : _c.gist) === null || _d === void 0 ? void 0 : _d.id);
        getTimeToRentExpiryInMilliSeconds(contentId).then(function (delay) {
            // delay === 0 -> rented content has expired
            // delay is null -> content is not rented
            // delay > 0 -> rental period is valid, will expire in future
            if (delay === 0)
                isUserAvailable(true); // content already expired, show checkout
            if (delay && delay > 0)
                _delay = setTimeout(function () { return isUserAvailable(true); }, delay); // register reset handler to execute after delay
        });
        isUserAvailable();
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var userParam = urlParams.get("user");
        if (userParam === "registered") {
            setShowCheckout(true);
        }
        subscribeRedirectWithOptions(handleNavigate);
        var subscription = pubsub.subscribe("showVideoCheckout", handleCheckoutFlow);
        return function () {
            pubsub.unsubscribe(subscription);
            if (_delay)
                clearTimeout(_delay);
        };
    }, []);
    return (React.createElement(React.Fragment, null, user !== null ?
        React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) }, renderLazyComponent())
        : React.createElement(Spinner, null)));
};
export default VideoDetail02;
